import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web'; // Import react-spring for animations
import './Hero.css';
import video1 from '../../../assets/videos/HomeHeroVideos/Hero_Home_01.mp4';
import video2 from '../../../assets/videos/HomeHeroVideos/Hero_Home_02.mp4';
import video3 from '../../../assets/videos/HomeHeroVideos/Hero_Home_03.mp4';

const Hero = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  // Array of videos to randomly select from
  const videos = [video1, video2, video3];

  // Select random video on component mount
  const [selectedVideo] = useState(() => {
    const randomIndex = Math.floor(Math.random() * videos.length);
    return videos[randomIndex];
  });

  // Bounce-in animation for the heading
  const headingAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(-50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 170, friction: 26 },
    delay: 200, // Slight delay for staggered effect
  });

  // Fade-in animation for the description
  const descriptionAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 20 },
    delay: 300, // Description appears after heading
  });

  // Animation for video load-in
  const videoAnimation = useSpring({
    opacity: isVideoLoaded ? 1 : 0,
    transform: isVideoLoaded ? 'translateY(0px)' : 'translateY(50px)',
    config: { tension: 120, friction: 20 },
  });

  // Handle video load event
  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div className="hero">
      {/* Heading with animation */}
      <animated.div style={headingAnimation} className="hero-heading">
        <h1>
          WIN ATTENTION WITH <br /> EVERYDAY CREATIVITY
        </h1>
      </animated.div>

      {/* Description with animation */}
      <animated.p style={descriptionAnimation} className="hero-description">
        Good for Business. Good for Society.
      </animated.p>

      {/* Video with animation */}
      <animated.div style={videoAnimation} className="hero-video-container">
        <video
          className="hero-video"
          onLoadedData={handleVideoLoad}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={selectedVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </animated.div>
    </div>
  );
};

export default Hero;
